import { storage } from '../config';
import { PROPERTY_TYPES } from '../constants';
import { capitalize } from '../utils/format';

function isUrl(str) {
  const pattern = /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/|www.)/;
  return pattern.test(str);
}

export function getImage(
  image,
  type = PROPERTY_TYPES.BUILDINGS,
  convertSequenceToNumber = false,
  assumeJpg = false,
) {
  const singularType = /s$/.test(type) ? type.slice(0, -1) : type;
  const placehold = `${storage.distPath}/${singularType}-placeholder-img.svg`;
  const { cloudStoragePath } = storage;
  const origFilename = image.filename ? image.filename.trim() : undefined;

  const hasFileExt = origFilename ? origFilename.indexOf('.') > 0 : false;
  const imageSequence = image.sequence ? image.sequence : '-1';
  const sequence = convertSequenceToNumber ? Number(imageSequence) : imageSequence;
  const fallback = (!hasFileExt && assumeJpg) ? `${cloudStoragePath}/${origFilename}.jpg` : placehold;
  const desc = image.description_tx ? image.description_tx : capitalize(singularType);
  let filename;
  if (isUrl(origFilename)) {
    // `${cloudFrontPath}/${Buffer.from(encodeURI(
    // decodeURIComponent(origFilename))).toString('base64')}`;
    filename = origFilename;
  } else if (hasFileExt) {
    filename = `${cloudStoragePath}/${origFilename}`;
  } else {
    filename = fallback;
  }

  return {
    sequence,
    filename,
    description: `${desc} photo`,
    fallback,
  };
}

export function getPropertyImages(property, type) {
  const convertSequenceToNumber = true;
  const assumeJpg = true;
  const {
    attachments: {
      images: imageObjects = [],
    } = {},
  } = property;
  return imageObjects
    .map(image => getImage(image, type, convertSequenceToNumber, assumeJpg))
    .sort((a, b) => (a.sequence > b.sequence ? 1 : -1));
}

export function getAreaImages(overview) {
  const convertSequenceToNumber = true;
  const assumeJpg = true;
  const {
    details: {
      attachments: {
        images: imageObjects = [],
      } = {},
    } = {},
  } = overview;
  return imageObjects
    .map(image => getImage(image, 'site', convertSequenceToNumber, assumeJpg))
    .sort((a, b) => (a.sequence > b.sequence ? 1 : -1));
}

export default getImage;



// WEBPACK FOOTER //
// ./src/utils/attachmentUtils.js